import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './messages/en.json';
import no from './messages/no.json';
import fr from './messages/fr.json';

const LOCALE_STORAGE_KEY = 'runnershub_locale';

export const localeNames: Record<string, string> = {
  en: 'English',
  no: 'Norsk',
  nb: 'Norsk',
  fr: 'Français',
};

export const supportedLocales = ['en', 'no', 'nb', 'fr'] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      no: { translation: no },
      nb: { translation: no },
      fr: { translation: fr },
    },
    fallbackLng: {
      fr: ['en', 'no'],
      default: ['en', 'no'],
    },
    supportedLngs: supportedLocales,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
    },
  });

export default i18n;
export { LOCALE_STORAGE_KEY };
